import Tip from '@/components/Tip/Tip';
import IRootPageLink from '@/types/IRootPageLink';
import {
	Button,
	Heading,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Tab,
	TabList,
	TabPanels,
	Tabs,
} from '@chakra-ui/react';
import useAddLinkModal from './AddLink.modal.controller';
import AddLinkGroupTab from './tabs/link-group/link-group.tab';
import AddServiceTab from './tabs/service/AddService.tab';
import AddWebsiteTab from './tabs/website/AddWebsite.tab';

interface AddLinkModalProps {
	isOpen: boolean;
	close: () => void;
	onLinkAdded: (link: IRootPageLink) => Promise<void>;
}

export default function AddLinkModal(props: AddLinkModalProps) {
	const { t, form, service, rootPage, setRootPage, setService, submitForm, handleClose } = useAddLinkModal(props);

	return (
		<>
			<Modal isOpen={props.isOpen} onClose={props.close} size="2xl" isCentered>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>
						<Heading size="lg">{t('Create a new link')}</Heading>
					</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Tip>{t('Select the type of link you want to add to the group.')}</Tip>

						<Tabs isLazy variant="enclosed" size={{ base: 'sm', md: 'md' }} onChange={handleClose}>
							<TabList>
								<Tab>{t('Service')}</Tab>
								<Tab>{t('Website')}</Tab>
								<Tab>{t('Link group')}</Tab>
							</TabList>

							<TabPanels
								borderWidth={1}
								borderStyle="solid"
								borderColor="gray.200"
								borderBottomRadius="md"
								pb="4"
								mb="4"
							>
								<AddServiceTab service={service} setService={setService} form={form} />
								<AddWebsiteTab form={form} />
								<AddLinkGroupTab rootPage={rootPage} setRootPage={setRootPage} form={form} />
							</TabPanels>
						</Tabs>
					</ModalBody>

					<ModalFooter>
						<Button variant="ghost" mr={3} onClick={props.close}>
							{t('Close')}
						</Button>
						<Button
							isDisabled={!form.formState.isValid}
							isLoading={form.formState.isSubmitting}
							colorScheme="primary"
							onClick={submitForm}
						>
							{t('Add new link')}
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
}
